import { DATE_FORMAT } from "@constants/dates";
import moment from "moment";

export const extractDate = (value: string): string => moment.parseZone(value).format(DATE_FORMAT);

export const isDateOnly = (dateString: string): boolean => moment(dateString, 'YYYY-MM-DD', true).isValid();

export const getStartOfDayString = (dateString: string, timeZone: string): string => moment.tz(dateString, timeZone).startOf('day').format();

export const getEndOfDayString = (dateString: string, timeZone: string): string => moment.tz(dateString, timeZone).endOf('day').format();

export const moveStringDateToTimezone = (dateString: string, timeZone: string): string => moment.tz(dateString, timeZone).format();